import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import Navbar from '../../../components/Navbar';
import Background from '../../../components/Background';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import style from './PageSeg.module.css';

const PageSeg = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar motivados />
      <Header />
      <Background />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div onClick={() => navigate("")}>
              SEGURANÇA DO TRABALHO
            </div>
          </div>
          <div className={style.table}>
            <div className={style.table_outer_container}>
              <div className={style.table_container}>
                {/* Três quadrados de navegação com ícones */}
                <div className={style.table_item} onClick={() => navigate("/segtrabalho/forms")}>
                  <i className="fas fa-clipboard-check"></i> Formulário de Inspeção
                </div>
                <div className={style.table_item} onClick={() => navigate("/segtrabalho/fluxogramaatendimento")}>
                  <i className="fas fa-sitemap"></i> Fluxograma de Atendimento a Emergência
                </div>
                <div className={style.table_item} onClick={() => navigate("/segtrabalho/laudosequipamentos")}>
                  <i className="fas fa-tools"></i> Laudos de Equipamentos
                </div>
                <div className={style.table_item} onClick={() => navigate("/segtrabalho/inserirdocs")}>
                  <i className="fas fa-folder-open"></i> Inserir Documentos
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <PageSeg />
    </SnackbarProvider>
  );
}
